import React from "react";
import "./StatsSection.css";

const StatsSection = () => {
  const stats = [
    {
      number: "500K+",
      label: "Downloads",
      description: "Users transforming their lives",
    },
    {
      number: "4.8",
      label: "App Rating",
      description: "Stars across platforms",
    },
    {
      number: "100+",
      label: "Countries",
      description: "Global reach and impact",
    },
    {
      number: "1M+",
      label: "Challenges Completed",
      description: "Daily wins stacking up",
    },
  ];

  return (
    <section className="stats" id="stats">
      <div className="stats-container">
        <div className="stats-header">
          <span className="stats-label">THE NUMBERS DON'T LIE</span>
          <h2 className="stats-title">
            REAL <span className="gold">IMPACT</span>
          </h2>
        </div>

        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div className="stat-card" key={index}>
              <div className="stat-number">{stat.number}</div>
              <div className="stat-label">{stat.label}</div>
              <div className="stat-description">{stat.description}</div>
            </div>
          ))}
        </div>

        <div className="stats-divider">
          <div className="divider-line"></div>
          <span className="divider-text">AND GROWING</span>
          <div className="divider-line"></div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
